import React, { FC, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useFlags } from 'app/flagsmith';
import { featureFlags, isFeatureEnabled } from 'app/flagsmith/features';
import { CVEDetails } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Vulnerability/CVE/CVEDetails';
import { selectVulnerabilities } from 'containers/Visibility/Vulnerabilities/selectors';
import { actions } from 'containers/Visibility/Vulnerabilities/slice';

interface Props {
  isOpen: boolean;
  onClose();
  currentRecord?: Record<string, any>;
  cveId?: string;
}

export const CVEDetailsDrawer: FC<Props> = props => {
  const { isOpen, onClose, currentRecord, cveId } = props;
  const dispatch = useDispatch();
  const { cveDetails } = useSelector(selectVulnerabilities);
  const [data, setData] = useState<Record<string, any>>({});
  const { new_vuln_dashboard: vulnerabilityV3Flag } = useFlags([
    featureFlags.vulnerabilityV3,
  ]);
  const useScanVaultVulnerabilityFindings = isFeatureEnabled(
    vulnerabilityV3Flag,
  );

  useEffect(() => {
    //!!currentRecord && setData(currentRecord);
  }, [currentRecord]);

  useEffect(() => {
    if (!!cveId)
      dispatch(
        actions.getCVEDetails({
          q: {
            cVEByIDRequest: { vulnerability_ids: [cveId] },
            page: 1,
            pageSize: 1,
            useScanVaultVulnerabilityFindings,
          },
          onSuccess: res => {
            setData(res?.items?.[0] ?? {});
          },
        }),
      );
    else setData(currentRecord ?? {});
  }, [cveId, dispatch, currentRecord, useScanVaultVulnerabilityFindings]);

  return (
    <CVEDetails
      currentTechInstance={data}
      isOpen={isOpen}
      onClose={onClose}
      isLoading={cveDetails.isLoading}
    />
  );
};
